import { ENABLE_GITHUB } from '@core/constant/featureFlags';
import { throwOnErr } from '@core/util/result';
import { agentHarnessServiceClient } from '@service-agent-harness/client';
import { useQuery } from '@tanstack/solid-query';
import { agentRepositoryKeys } from './keys';

function fetchAgentRepositories() {
  return throwOnErr(() => agentHarnessServiceClient.listRepositories());
}

/**
 * The GitHub repositories the signed-in user can hand a coding session: every
 * repository under an installation of Macro's GitHub App they or their teams
 * made. The same list the create-session API authorizes an explicit
 * repository against, so what a picker offers is exactly what a session may
 * select.
 *
 * Kept fresh for a while: the harness caches the listing for ten minutes
 * itself, and installing the App somewhere new is rare and deliberate.
 */
export function useAgentRepositoriesQuery(enabled: () => boolean = () => true) {
  return useQuery(() => ({
    queryKey: agentRepositoryKeys.list.queryKey,
    queryFn: fetchAgentRepositories,
    enabled: ENABLE_GITHUB && enabled(),
    staleTime: 5 * 60 * 1000,
  }));
}
